import { Entity, Field } from "typegraph";
import TagSet from "./TagSet";

@Entity({one:"tag", many:"tags"})
export default class Tag {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public userSelected:boolean;

	@Field({entity: TagSet})
	public tagSet: TagSet;

}



// WEBPACK FOOTER //
// ./src/panels/recommended/userPreferences/entities/Tag.ts